export interface ProgressiveImageState {
  imageError: boolean;
  imageLoading: boolean;
}

export type ProgressiveImageAction =
  | { type: 'SET_ERROR' }
  | { type: 'SET_LOADED' }
  | { type: 'RESET' };

export const initialState: ProgressiveImageState = {
  imageError: false,
  imageLoading: true,
};

export const progressiveImageReducer = (
  state: ProgressiveImageState,
  action: ProgressiveImageAction
): ProgressiveImageState => {
  switch (action.type) {
    case 'SET_ERROR':
      return {
        ...state,
        imageError: true,
        imageLoading: false,
      };
    case 'SET_LOADED':
      return {
        ...state,
        imageLoading: false,
        imageError: false,
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};
